import { gql } from "@apollo/client";

export const getGroupMembers = gql`
  query GetGroupMembers($groupId: String, $paginationArguments: PaginationArgumentsForwardInput) {
    GetGroupMembers(input: { groupId: $groupId, paginationArguments: $paginationArguments }) {
      connection {
        edges {
          cursor
          node {
            role {
              description
              groupId
              organizationId
              projectId
              roleId
              systemRole
              title
            }
            user {
              displayName
              email
              photoUrl
              userId
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        totalCount
      }
    }
  }
`;
